import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const Himchistka = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Химчистка - Клининговая компания Bell</title>
        <meta
          name="description"
          content="Профессиональная химчистка мягкой мебели, ковров, матрасов в Минске"
        />
      </Helmet>
      <div className="min-h-screen">
        <Header />

        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="container mx-auto px-4">
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-orange-600 hover:text-orange-700 font-medium mb-8 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span>Вернуться на главную</span>
            </Link>

            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
                Химчистка
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed mb-12">
                Профессиональная химчистка мягкой мебели, ковров, матрасов и других
                текстильных изделий. Используем современное оборудование и безопасные
                средства.
              </p>

              <div className="grid md:grid-cols-3 gap-6 mb-16">
                <div className="bg-white p-6 rounded-xl border-2 border-orange-100 shadow-sm">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Химчистка дивана
                  </h3>
                  <p className="text-3xl font-bold text-orange-600">от 80 р.</p>
                </div>
                <div className="bg-white p-6 rounded-xl border-2 border-orange-100 shadow-sm">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Химчистка ковра
                  </h3>
                  <p className="text-3xl font-bold text-orange-600">от 5 р./м²</p>
                </div>
                <div className="bg-white p-6 rounded-xl border-2 border-orange-100 shadow-sm">
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    Химчистка матраса
                  </h3>
                  <p className="text-3xl font-bold text-orange-600">от 50 р.</p>
                </div>
              </div>

              <div className="bg-gradient-to-br from-orange-50 to-orange-50 rounded-2xl p-8 md:p-12 text-left">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Преимущества нашей химчистки
                </h2>
                <ul className="space-y-4 text-gray-700 text-lg">
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>
                      Использование профессионального оборудования с глубокой очисткой
                    </span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>
                      Безопасные гипоаллергенные средства, подходящие для домов с
                      детьми и животными
                    </span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>
                      Удаление сложных пятен (вино, кофе, жир, чернила)
                    </span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>
                      Устранение неприятных запахов и бактерий
                    </span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>Быстрое высыхание - уже через 2-4 часа можно пользоваться</span>
                  </li>
                  <li className="flex items-start space-x-3">
                    <span className="text-orange-600 font-bold">✓</span>
                    <span>Гарантия на выполненную работу</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <ContactForm />
        <Footer />
      </div>
    </>
  );
};

export default Himchistka;